import { CardsInputBlock } from '@coast/schemas';
import { isNil } from 'lodash';
import { LinkedCard } from '@shared/components/blocks/lib/cards';
import { CardFieldItem } from '@shared/components/blocks/types';
import { RelatedCardComponent } from '@shared/scenes/workflows/config';
import { isRelatedCardComponent } from '@shared/scenes/workflows/utils';
import { API } from '@shared/types/api';

export function getRelatedCardComponent(
  workflowTemplate: API.WorkflowTemplateFragment | undefined,
  block: CardsInputBlock,
): RelatedCardComponent {
  const component = workflowTemplate?.components.find(workflowComponent => {
    return workflowComponent.id === block.name;
  });
  // @ts-expect-error -- strict migration
  if (isRelatedCardComponent(component)) {
    return component;
  }
  // @ts-expect-error -- strict migration
  return null;
}

export function resolveLinkedCards(
  summaryCards: NonNullable<API.ListSummaryCardsQuery['listSummaryCards']['cards']>,
  cardItems: CardFieldItem[],
): LinkedCard[] {
  const cards: LinkedCard[] = [];
  cardItems.forEach((item: CardFieldItem) => {
    const summaryCard = summaryCards?.find(
      (card: NonNullable<API.ListSummaryCardsQuery['listSummaryCards']['cards']>[number]) =>
        item.id === card.id,
    );
    if (!isNil(summaryCard)) {
      cards.push({
        cardId: summaryCard.id,
        name: summaryCard.name,
        quantity: item.quantity,
      });
    }
  });
  return cards;
}
